import angular, {
    IController,
    IDirective,
    IScope,
    IWindowService,
} from 'angular';
import { IRootScope } from '../../tn.common';

export interface IExpandoScope extends IScope {
    isActive: boolean;
    animate: boolean;
    speed: number;
}

export class ExpandoController implements IController {
    toolbarElement?: HTMLElement;
    private __$element?: JQLite;
    __element?: HTMLElement;

    constructor(
        protected $rootScope: IRootScope,
        protected $scope: IExpandoScope,
        protected $window: IWindowService
    ) {}

    protected runAnimation(): void {
        const { element } = this;
        if (!element) {
            return;
        }
        if (this.active) {
            const children = angular
                .element(element)
                .children(':not(.expando_head)')
                .hide();
            angular.element(element).addClass('active');
            children.stop().slideDown({
                duration: this.$scope.speed,
                start() {
                    angular
                        .element(element)
                        .addClass(
                            'active expando_active ' +
                                'expando_animating expando_animating_activating'
                        )
                        .removeClass('collapsed expando_collapsed');
                },
                complete() {
                    angular
                        .element(element)
                        .removeClass(
                            'expando_animating expando_animating_activating'
                        );
                },
            });
        } else {
            angular
                .element(element)
                .children(':not(.expando_head)')
                .stop()
                .slideUp({
                    duration: this.$scope.speed,
                    start() {
                        angular
                            .element(element)
                            .addClass(
                                'expando_animating expando_animating_deactivating'
                            );
                    },
                    complete() {
                        angular
                            .element(element)
                            .removeClass(
                                'active expando_active ' +
                                    'expando_animating expando_animating_deactivating'
                            )
                            .addClass('collapsed expando_collapsed');
                    },
                });
        }
    }

    setActive(active: boolean, animate: boolean): void {
        this.$scope.isActive = active;

        if (animate) {
            this.runAnimation();
        } else {
            if (this.__$element) {
                const restoreClass =
                    this.__$element.hasClass('expando_animates');
                this.__$element.removeClass('expando_animates');
                if (this.$scope.isActive) {
                    this.__$element
                        .addClass('active expando_active')
                        .removeClass('collapsed expando_collapsed');
                } else {
                    this.__$element
                        .removeClass('active expando_active')
                        .addClass('collapsed expando_collapsed');
                }
                if (restoreClass) {
                    this.__$element.addClass('expando_animates');
                }
            }
        }
    }

    toggle(animate = true): void {
        this.setActive(!this.$scope.isActive, animate);
    }

    toggleExpando(animate = true): void {
        this.toggle(animate);
    }

    get active(): boolean {
        return this.$scope.isActive;
    }

    get element(): HTMLElement | undefined {
        return this.__element;
    }
    set element(value: HTMLElement | undefined) {
        this.__element = value;
        this.__$element =
            value != undefined ? angular.element(value) : undefined;
        if (this.__$element) {
            if (this.active) {
                this.__$element.addClass('active');
            } else {
                this.__$element.removeClass('active');
            }
        }
    }
}
ExpandoController.$inject = ['$rootScope', '$scope', '$window'];

/***
 * Explicit expandos do not auto-populate with templates. This allows custom control
 * over the contents of expando_head
 *
 *	Usage:
 *	<ANY tn-expando-explicit expando-active="true" expando-animate="false", expando-speed="400">
 *
 *	</ANY
 *
 */
ExpandoExplicit.$inject = [];
export function ExpandoExplicit(): IDirective<IExpandoScope> {
    return {
        restrict: 'EA',
        controller: ExpandoController,
        scope: {
            isActive: '@?expandoActive',
        },
        link(scope, element, attrs, expandoController) {
            scope.isActive = (scope.isActive || false).toString() === 'true';
            scope.animate = true;
            scope.speed = 200;

            // try to find an explicit expando declared
            let expandoEl = element.hasClass('expando')
                ? element
                : element.find('.expando').eq(0);

            // if we can't find an explicit expando, we are the expando;
            // assign to self and go.
            if (!expandoEl || expandoEl.length === 0) {
                expandoEl = element.addClass('expando');
            }

            expandoEl.addClass('expando_animates');

            // find direct expando head descendants, toggle on them
            expandoEl.children('.expando_head').click(() => {
                expandoController && expandoController.toggle(scope.animate);
            });

            if (expandoController) {
                const ele = expandoEl[0];
                expandoController.element = ele;
            }
            scope.isActive = false;
        },
    };
}
